import { useContext } from "react";
import { PayableInvoiceEmailRequestModel } from "@attelas/shared";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";
import useSWRMutation from "swr/mutation";
import { environment } from "../config/environment";

export const useStartInvoiceEmailExtraction = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { trigger, isMutating, error } = useSWRMutation(
    `${environment.apiUrl}/api/payable-invoices/email`,
    (url: string, { arg }: { arg: PayableInvoiceEmailRequestModel }) =>
      fetcher<string[]>(url, {
        method: "POST",
        body: JSON.stringify(arg),
      }),
    {
      onError: () => {
        showToast("Failed to start invoice email extraction, please try again later", "error");
      },
    }
  );

  return {
    startInvoiceEmailExtraction: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
